import { Expose } from 'class-transformer'
import { IsBoolean, IsDefined } from 'class-validator'

export class DefaultDTO {
    @Expose()
    @IsDefined()
    @IsBoolean()
    success!: boolean
}
